module.exports = {
	"root": "findify-components--sorting",
	"icon": "findify-components--sorting__icon",
	"title": "findify-components--sorting__title",
	"dropdown": "findify-components--sorting__dropdown"
};